import { render, staticRenderFns } from "./AvatarPreview.vue?vue&type=template&id=451f0db8&scoped=true&"
import script from "./AvatarPreview.vue?vue&type=script&lang=js&"
export * from "./AvatarPreview.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPreview.vue?vue&type=style&index=0&id=451f0db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f0db8",
  null
  
)

export default component.exports